module.exports = __webpack_public_path__ + "img/icon_t4.e2ad5136.png";